import { useState } from "react";
import { Button } from "@material-ui/core";
import { PaymentElement, useStripe, useElements, ExpressCheckoutElement } from "@stripe/react-stripe-js";
import { LocalizerHelper } from "../../helpers/localizerHelper";
import { LoaderGif } from "../loader";
import './stripe.scss';

const StripeCheckoutForm = () => {
  const stripe = useStripe();
  const elements = useElements();
  const [isLoading, setIsLoading] = useState(false);

const handleSubmit = async (e: any) => {
    e.preventDefault();
    if (!stripe || !elements) return;

    setIsLoading(true);

    const { error, paymentIntent } = await stripe.confirmPayment({
      elements,
      confirmParams: {
        return_url: window.location.href,
      },
      redirect: "if_required",
    });

    if (error) {
      setIsLoading(false);
      alert(error.message);
      return;
    }

    if (paymentIntent?.status === "succeeded") {
      // keep loading — session useEffect will navigate to /thanks
    } else {
      setIsLoading(false);
    }
  };

  const handleExpressConfirm = async () => {
    if (!stripe || !elements) return;

    setIsLoading(true);

    // ExpressCheckoutElement uses confirmPayment internally,
    // so just confirm without passing elements
    const expressCheckout = elements.getElement("expressCheckout");
    if (!expressCheckout) {
      setIsLoading(false);
      return;
    }

    const { error, paymentIntent } = await stripe.confirmPayment({
      elements,
      confirmParams: {
        return_url: window.location.href,
      },
      redirect: "if_required",
    });

    if (error) {
      setIsLoading(false);
      alert(error.message);
      return;
    }

    if (paymentIntent?.status === "succeeded") {
      // keep loading — session useEffect will navigate to /thanks
    } else {
      setIsLoading(false);
    }
  };

  return (
    <form onSubmit={handleSubmit}>
      <div className="row mb-3 justify-content-center">
        <div className="col-md-10">
          <div className="stripe-element-container">
            <ExpressCheckoutElement
              onConfirm={handleExpressConfirm}
              options={{
                layout: { maxColumns: 2, overflow: "never" },
                paymentMethods: {
                  googlePay: "always",
                  applePay: "always",
                  link: "never",
                },
              }}
            />
            <div style={{ marginTop: "16px" }}>
              <PaymentElement options={{ layout: "tabs" }}/>
            </div>
          </div>
          {isLoading && (
            <LoaderGif 
              image="/assets/loading_check_payment.gif" 
              message={LocalizerHelper.localized('loading_msg_check_payment')} 
            />
          )}
        </div>
      </div>

      <div className="row justify-content-center">
        <div className="col-md-10">
          <Button className="accent-button full-width" type="submit" disabled={isLoading}>
            {LocalizerHelper.localized('proceed_with_payment')}
          </Button>
        </div>
      </div>
    </form>
  );
};

export default StripeCheckoutForm;